import clsx from 'clsx';

import { PollQuestion } from '../../../../../../db/polls/types';
import { POLL_QUESTION_MIN_FONT_SIZE } from '../../../constants';
import { publishedQuestionDescriptionClasses, ReadonlyDescription, Root, TemporaryReadonlyDescription } from './styles';
import usePublishedQuestionDescription from './vm';

export interface PublishedQuestionDescriptionProps {
  pollQuestion: PollQuestion | undefined;
  className?: string;
}

const PublishedQuestionDescription = ({ pollQuestion, className }: PublishedQuestionDescriptionProps) => {
  const { getDownloadAttachmentRequestConfig, temporaryRichTextViewRef, richTextFinalFontSize } =
    usePublishedQuestionDescription();

  if (!pollQuestion) return null;

  const { description, attachments } = pollQuestion;

  return (
    <Root className={className}>
      <ReadonlyDescription
        fontSize={richTextFinalFontSize ?? POLL_QUESTION_MIN_FONT_SIZE}
        richtext={description}
        attachments={{ files: attachments, requestConfig: getDownloadAttachmentRequestConfig }}
        className={publishedQuestionDescriptionClasses.readonlyDescription}
      />
      {!richTextFinalFontSize && (
        <TemporaryReadonlyDescription
          rootRef={temporaryRichTextViewRef}
          richtext={description}
          attachments={{ files: attachments, requestConfig: getDownloadAttachmentRequestConfig }}
          className={publishedQuestionDescriptionClasses.temporaryReadonlyDescription}
        />
      )}
    </Root>
  );
};

export default PublishedQuestionDescription;
